const formLabelFormParamUser = {
  text: 'Tipo de Acceso'
};

export default formLabelFormParamUser;
